import StarSelect from './StarSelect';
export default StarSelect;
